import { useEffect, useState } from "react";
import styles from "@/features/Explorer/Explorer.module.scss";
import { UniqueIdentifier } from "@dnd-kit/core";

export const useDropIntoListAnimation = () => {
  const [
    updateCompleteId,
    setUpdateCompleteId
  ] = useState<null | string | UniqueIdentifier>(null);

  useEffect(() => {
    if (updateCompleteId) {
      const element = document.querySelector(`[data-id="${updateCompleteId}"]`)
        ?.querySelector(`[data-field="playBack"]`);

      if (element) {
        element.classList.add(styles.FolderDraggedInto);
        element.addEventListener('animationend', () => {
          element.classList.remove(styles.FolderDraggedInto);
          setUpdateCompleteId(null);
        }, { once: true });
      }
    }
  }, [updateCompleteId]);

  return [
    updateCompleteId,
    setUpdateCompleteId
  ]
}
